import { React, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import Table from 'react-bootstrap/Table';

import ProfileAvatar from "../../../ui/ProfileAvatar";
import Button from "../../../ui/Button";
import SkeletonLoader from "../../../ui/SkeletonLoader";

import UpdateCustomerStatusModal from "../UpdateCustomerStatusModal";

import { getCustomerImageUrl, formatDate, formatNumber } from "../../../../utils/util";


const CutomersListView = ({ customersList, isLoading }) => {

    const { t } = useTranslation();

    const navigate = useNavigate();

    const [showUpdateCustomerStatusModal, setShowUpdateCustomerStatusModal] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState({});

    const updatedUserStatus = (data) => {
        setSelectedCustomer(data);
        setShowUpdateCustomerStatusModal(true);
    }
    
    return (
        <Row>
            <Col md="12">
                {
                    isLoading ?
                        <div className="list-view-container organization-list-view-table p-3">
                            <SkeletonLoader type={"line"} count={5} currentPage={"customer"} />
                        </div>
                    :
                    <div className="list-view-container organization-list-view-table p-3">
                        <Table responsive="lg">
                            <thead>
                                <tr>
                                    <th>{t("customers.customersListView.customerName")}</th>
                                    <th>{t("customers.customersListView.subscriptionType")}</th>
                                    <th>{t("customers.customersListView.SubscriptionEndDate")}</th>
                                    <th>{t("customers.customersListView.totalPortFolioEisk")}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    customersList.results.length > 0 &&
                                    customersList.results.map((data, index)=>{
                                        return (
                                            <motion.tr
                                                key={data.customer_id}
                                                initial={{ opacity: 0, y: 20 }}
                                                // whileInView={{ opacity: 1, y: 0 }}
                                                // viewport={{ once: true }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                            >
                                                <td>
                                                    <ProfileAvatar pageType={"organizationHomePage"} type="domain" name={data?.name} secondaryText={`Created On : ${formatDate(data?.created_at)}`} imageUrl={getCustomerImageUrl(data)} />                                                               
                                                </td>
                                                <td>
                                                    {data?.subscription?.name === "trial" ? "Demo" : "Business"}
                                                </td>
                                                <td>
                                                    {formatDate(data?.subscription?.end_date)}
                                                </td>
                                                <td>
                                                    <div className="risk-count">
                                                        <span className="critical">{t("organizationPage.critical")} {formatNumber(data.stats.domain_portfolio_risks.critical_risk)}</span>
                                                        <span className="high">{t("organizationPage.high")} {formatNumber(data.stats.domain_portfolio_risks.high_risk)}</span>
                                                        <span className="medium">{t("organizationPage.medium")} {formatNumber(data.stats.domain_portfolio_risks.medium_risk)}</span>
                                                        <span className="low">{t("organizationPage.low")} {formatNumber(data.stats.domain_portfolio_risks.low_risk)}</span>
                                                    </div> 
                                                </td>
                                                <td>
                                                    <div className='organization-list-view users-list-view-btn customers-action-btn d-flex'>
                                                        {data.status !== "active" &&<button className="view-details-btn active-user w-100" onClick={()=>{updatedUserStatus(data)}}>{t('customers.customersListView.activateButton')}</button>}
                                                        {data.status === "active" && <button className="view-details-btn disable-user w-100" onClick={()=>{updatedUserStatus(data)}}>{t('customers.customersListView.deActivateButton')}</button>}
                                                        <Button buttonText={"View Details"} buttonType="primary" buttonClicked={()=>{navigate(`/customers/details/${data?.customer_id}`)}}/>
                                                    </div>
                                                </td>
                                            </motion.tr>
                                        )
                                    })
                                }
                            </tbody>
                        </Table>
                        <UpdateCustomerStatusModal show={showUpdateCustomerStatusModal} onHide={()=>{setShowUpdateCustomerStatusModal(false)}} selectedCustomer={selectedCustomer} />
                    </div>
                }                
            </Col>
        </Row>
    )
}

export default CutomersListView;